// Proje notu ekleme/düzenleme modal'ı
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useMutation, useQueryClient } from 'react-query';
import { FiX } from 'react-icons/fi';
import { projectService } from '../../services/projectService';
import toast from 'react-hot-toast';

const ProjectNoteModal = ({ projectId, note, onClose, onSuccess }) => {
  const queryClient = useQueryClient();
  const [isLoading, setIsLoading] = useState(false);
  
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue
  } = useForm();

  // Not oluşturma/güncelleme mutation'ı
  const saveNoteMutation = useMutation(
    (data) => {
      if (note) {
        // Not güncelleme
        return projectService.updateNote(note.id, data);
      } else {
        // Yeni not ekleme
        return projectService.addNote(projectId, data);
      }
    },
    {
      onSuccess: (data) => {
        toast.success(note ? 'Not güncellendi' : 'Not eklendi');
        queryClient.invalidateQueries(['project', projectId]);
        onSuccess();
      },
      onError: (error) => {
        toast.error(error.response?.data?.message || 'İşlem başarısız');
      }
    }
  );

  // Form'u not verileriyle doldur
  useEffect(() => {
    if (note) {
      setValue('project_notes', note.project_notes);
      setValue('note_type', note.note_type);
    }
  }, [note, setValue]);

  // Form gönderimi
  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      await saveNoteMutation.mutateAsync(data);
    } catch (error) {
      console.error('Form gönderim hatası:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content max-w-2xl">
        {/* Modal header */}
        <div className="modal-header">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-medium text-white">
              {note ? 'Not Düzenle' : 'Yeni Not'}
            </h3>
            <button
              onClick={onClose}
              className="text-white hover:text-gray-300"
            >
              <FiX size={20} />
            </button>
          </div>
        </div>

        {/* Modal body */}
        <form onSubmit={handleSubmit(onSubmit)} className="p-6 space-y-6">
          {/* Not tipi */}
          <div>
            <label htmlFor="note_type" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Not Tipi *
            </label>
            <select
              id="note_type"
              {...register('note_type', { required: 'Not tipi gerekli' })}
              className={`input-field ${errors.note_type ? 'input-error' : ''}`}
            >
              <option value="">Tip seçin</option>
              <option value="Toplantı Notu">Toplantı Notu</option>
              <option value="Bilgi Notu">Bilgi Notu</option>
              <option value="Uyarı Notu">Uyarı Notu</option>
              <option value="Hatırlatma Notu">Hatırlatma Notu</option>
            </select>
            {errors.note_type && (
              <p className="mt-1 text-sm text-red-600">{errors.note_type.message}</p>
            )}
          </div>

          {/* Not içeriği */}
          <div>
            <label htmlFor="project_notes" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Not İçeriği *
            </label>
            <textarea
              id="project_notes"
              rows={6}
              {...register('project_notes', { required: 'Not içeriği gerekli' })}
              className={`input-field ${errors.project_notes ? 'input-error' : ''}`}
              placeholder="Not içeriğini girin..."
            />
            {errors.project_notes && (
              <p className="mt-1 text-sm text-red-600">{errors.project_notes.message}</p>
            )}
          </div>

          {/* Modal footer */}
          <div className="flex items-center justify-end space-x-3 pt-6 border-t border-gray-200 dark:border-gray-700">
            <button
              type="button"
              onClick={onClose}
              className="btn-secondary"
              disabled={isLoading}
            >
              İptal
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={isLoading}
            >
              {isLoading ? 'Kaydediliyor...' : (note ? 'Güncelle' : 'Ekle')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProjectNoteModal;
